import ProyectosAdminList from 'components/Proyectos/ProyectosAdminList'
import PageTitle from 'components/ui/Title/PageTitle'


export const ProyectosPage = () => {
  return (

    <div className='jorge'>
      <PageTitle>Proyectos</PageTitle>
      
      <ProyectosAdminList />
    </div>

  )
}
export default ProyectosPage